import React from "react";
import { analyticsCopilotWidgetsSectionId } from "../constants";
import { InsWidgetEditModeControls } from "./insWidgetEditModeControls";
import { InsWidgetViewModeControls } from "./insWidgetViewModeControls";
import { preview } from "common/constants";
import { useIsEditMode } from "store/template";
export const InsWidgetControls = (props) => {
    const isPreviewMode = props.sectionId === preview.sectionId;
    const isWidgetRenderedInCopilotPanel = props.sectionId === analyticsCopilotWidgetsSectionId;
    const isEditMode = useIsEditMode() && !isPreviewMode && !isWidgetRenderedInCopilotPanel;
    if (isEditMode) {
        return React.createElement(InsWidgetEditModeControls, { ...props });
    }
    return React.createElement(InsWidgetViewModeControls, { ...props });
};
